import { createStore } from 'vuex';

// @ts-ignore
import GeneralModule from './general.module'

// @ts-ignore
import CompanyModule from "./company.module";

// @ts-ignore
import OrderModule from "./order.module";
// @ts-ignore
import VehicleModule from "./vehicle.module";
// @ts-ignore
import OrderFalseDriverModule from "./orderFalseDriver.module";
// @ts-ignore
import OrderTrueDriverModule from "./orderTrueDriver.module";
// @ts-ignore
import customerModule from "./customer.module";
// @ts-ignore
import orderTrueDriverDateFrequencyModule from "./orderTrueDriverDateFrequency.module";
// @ts-ignore
import OrderTrueRoundTripModule from "./orderTrueRoundTrip.module";
// @ts-ignore
import OrderFalseRoundTripModule from "./orderFalseRoundTrip.module";
// @ts-ignore
import socialAuthModule from "./socialAuth.module";
// @ts-ignore
import OrderTrueDriverTravelObjectivesModule from "./orderTrueDriverTravelObjectives.module";

const store = createStore({
    state: {
        env: {
            // @ts-ignore
            appEnv: process.env.APP_ENV,
            // @ts-ignore
            apiUrl: process.env.MIX_API_URL,
            // @ts-ignore
            appUrl: process.env.MIX_APP_URL,
        },

        // firstName: 'John',
        // lastName: 'Doe',
        // favorites: []
    }, // Usage $store.state.firstName
    mutations: {
        // UPDATE_FAVORITES(state, payload) {
        //     state.favorites = payload
        // }
    },
    actions: {
        // addToFavorites(context, payload) {
        //     const favorites = context.state.favorites
        //     favorites.push(payload)
        //     context.commit('UPDATE_FAVORITES', favorites)
        // }
    },
    getters: {
        // fullName: function (state) { // Usage $store.getters.fullName
        //     return `${state.firstName} ${state.lastName}`
        // }
        apiUrl: (state) => state.env.apiUrl + '/',
        appUrl: (state) => state.env.appUrl + '/',
    },
    modules: {
        general: GeneralModule,
        company: CompanyModule,
        customer: customerModule,
        vehicle: VehicleModule,
        order: OrderModule,
        orderFalseDriver: OrderFalseDriverModule,
        orderTrueDriver: OrderTrueDriverModule,
        orderTrueDriverDates: orderTrueDriverDateFrequencyModule,
        orderTrueRoundTrip: OrderTrueRoundTripModule,
        socialAuth: socialAuthModule,
        orderFalseRoundTrip: OrderFalseRoundTripModule,
        orderTrueDriverTravelObjectives: OrderTrueDriverTravelObjectivesModule
    }
});

// Example
// <template>
//     <div class="wrapper">
//         <p>{{ $store.getters.fullName }}</p>
//         <div v-for="airport in airports" :key="airport.abbreviation">
//         <airport-card :airport="airport" @click="$store.dispatch('addToFavorites', airport)" />
//     </div>
//     <h2 v-if="$store.state.favorites.length">Favorites</h2>
//     <div v-for="airport in $store.state.favorites" :key="airport.abbreviation">
//     <airport-card :airport="airport"  />
// </div>
// </div>
// </template>

export default store;